import axios from 'axios'
import { getAuthHeader } from './config'

const baseURL = '/users'

const register = async (credentials) => {
  const response = await axios.post(`${baseURL}/register`, credentials);
  return response.data
}

const login = async (credentials) => {
  const response = await axios.post(`${baseURL}/login`, credentials)
  return response.data
}

const logout = async () => {
  await axios.post(`${baseURL}/logout`, undefined, getAuthHeader())
}

const update = async (user) => {
  const response = await axios.patch(
    `${baseURL}/me`,
    {
      name: user.name,
      email: user.email,
      mobile: user.mobile,
      username: user.username,
      photo: user.photo
    },
    getAuthHeader()
  )
  return response.data
}

const getMe = async (token) => {
  const options = {}
  if (token) {
    options.headers = {
      Authorization: `Bearer ${token}`
    }
  }
  const response = await axios.get(`${baseURL}/me`, options)
  return response.data
}

const updateOAuthRole = async (role, token) => {
  const response = await axios.post(
    `${baseURL}/oauth/update-role`,
    { role, token },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return response.data
}

const setNewsletterPreference = async (subscribed) => {
  const response = await axios.post(
    `${baseURL}/newsletter`,
    { subscribed },
    getAuthHeader()
  )
  return response.data
}

// Public: subscribe with email only (no login required)
const subscribeNewsletterEmail = async (email) => {
  const response = await axios.post(`${baseURL}/newsletter/subscribe`, { email })
  return response.data
}

const usersService = {
  register,
  login,
  logout,
  update,
  getMe,
  updateOAuthRole,
  setNewsletterPreference,
  subscribeNewsletterEmail
}
export default usersService
